import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  VERIFY_MDS_PPS_REQUEST,
  VERIFY_MDS_PPS_SUCCESS,
  VERIFY_MDS_PPS_FAILURE,
  VERIFY_MDS_PPS_LOADING,
} = therapyPlanningAction;

function* verifyMdsPps(action: any): SagaReturnType<any> {
  try {
    yield put({ type: VERIFY_MDS_PPS_LOADING });
    const response = yield call(therapyPlanningService.verifyMdsPps, action.payload);
    if (response?.status === 200) {
      yield put({ type: VERIFY_MDS_PPS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: VERIFY_MDS_PPS_FAILURE, payload: error });
  }
}

function* verifyMdsPpsSaga() {
  yield takeLatest(VERIFY_MDS_PPS_REQUEST, verifyMdsPps);
}

export default verifyMdsPpsSaga;
